import { Directive, ElementRef, OnInit, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[custom_draggable]',
    standalone: false
})
export default class DragDirective implements OnInit {

  constructor(public el: ElementRef) {
  }

  @Input() custom_draggable:boolean;

  public isDown = false;
  public disX!: number;
  public disY!: number;
  private totalOffsetX = 0;
  private totalOffsetY = 0;


  @HostListener('mousedown', ['$event']) onMousedown(event: MouseEvent) {
    if ( this.custom_draggable ){
      this.isDown = true;
      this.disX = event.clientX;
      this.disY = event.clientY;
    }
  }

  @HostListener('document:mousemove', ['$event']) onMousemove(event: MouseEvent) {
    if ( this.custom_draggable ){
      if (this.isDown) {
        this.el.nativeElement.style.left = this.totalOffsetX + event.clientX - this.disX + 'px';
        this.el.nativeElement.style.top = this.totalOffsetY + event.clientY - this.disY + 'px';
      }
    }
  }

  @HostListener('document:mouseup', ['$event']) onMouseup(event: MouseEvent) {
    //if ( this.draggable ){
      if (this.isDown) {
        this.totalOffsetX += event.clientX - this.disX;
        this.totalOffsetY += event.clientY - this.disY;
        this.isDown = false;
      }
    //}
  }

  ngOnInit() {
    //if ( this.draggable ){
      this.el.nativeElement.style.position = 'absolute';
      this.totalOffsetX = parseFloat(getComputedStyle(this.el.nativeElement).left);
      this.totalOffsetY = parseFloat(getComputedStyle(this.el.nativeElement).top);
    //}
  }
}